import * as React from 'react';
import Table from 'reactstrap/lib/Table';
import { TR } from 'src/TextRes';

export interface ITableBoxProps<T> {
    listData: T[];
    renderTBodyLine: (value: T, index: number) => void;
    renderTHeadLine?: JSX.Element;
    headerStyle?: string;
    bordered?: boolean;
}

export const TableBox = (props: ITableBoxProps<any>) => {
    const noResultsMessage = TR.tableBox_no_results;

    const headerClasses: string[] = [];

    if (props.headerStyle) {
        headerClasses.push(props.headerStyle);
    }

    if (!props.listData || props.listData.length < 1) {
        return (
            <legend className="my-3" style={{ color: 'red' }}>
                {noResultsMessage}
            </legend>
        );
    }

    return (
        <Table bordered={props.bordered === undefined || props.bordered} hover={true}>
            <thead className={headerClasses.join(' ')}>{props.renderTHeadLine ? props.renderTHeadLine : null}</thead>
            <tbody>{props.listData ? props.listData.map(props.renderTBodyLine) : props.renderTBodyLine}</tbody>
        </Table>
    );
};



// WEBPACK FOOTER //
// ./src/components/tableBox/TableBox.tsx